import api from "./api";

const fileVineApi = api.injectEndpoints({
  endpoints: (builder) => ({
    uploadFileVineRecord: builder.mutation({
      query: (config: { id: string; type: "patient" | "provider" }) => ({
        url: `fv/upload`,
        body: config,
        method: "POST",
      }),
      invalidatesTags: [
        { type: "Patients", id: "LIST" },
        { type: "Providers", id: "LIST" },
      ],
    }),
    verifyFileVineRecord: builder.query({
      query: (email: string) => ({
        url: `fv/verify/${email}`,
        method: "GET",
      }),
    }),
    getFileVineContacts: builder.query({
      query: (params) => ({
        url: `fv/contacts`,
        method: "GET",
        params,
      }),
      providesTags: [
        { type: "Providers", id: "LIST" },
        { type: "Patients", id: "LIST" },
      ],
    }),
  }),
});

export const {
  useUploadFileVineRecordMutation,
  useVerifyFileVineRecordQuery,
  useGetFileVineContactsQuery,
} = fileVineApi;
